import React from "react";
import Image from "next/image";
import { optimizedImageProps } from "../types";

interface BannerHeaderProps {
  img: optimizedImageProps;
  alt: string;
  heading: string;
  dark: boolean;
}

const BannerHeader: React.FC<BannerHeaderProps> = ({
  img,
  alt,
  heading,
  dark,
}) => {
  return (
    <div className="w-full max-md:h-[45vh] md:aspect-[10/4] md:min-h-[45vh]">
      <div className="relative inset-0 z-0 w-full max-md:h-[45vh] md:aspect-[10/4] md:min-h-[45vh]">
        <Image
          src={img.imageURL}
          placeholder="blur"
          blurDataURL={img.blurDataURL}
          alt={alt}
          fill
          quality={100}
          style={{
            objectFit: "cover",
            objectPosition: "center",
          }}
          priority={true}
        />
      </div>
      <div
        className={
          dark
            ? "absolute inset-0 w-full bg-zinc-800/50 max-md:h-[45vh] md:aspect-[10/4] md:min-h-[45vh]"
            : "absolute inset-0 w-full bg-zinc-800/20 max-md:h-[45vh] md:aspect-[10/4] md:min-h-[45vh]"
        }
      >
        <div className="mx-auto flex h-full w-full max-w-[1240px] items-center justify-center p-6 text-primary-light">
          <h1 className="text-3xl font-light uppercase sm:text-5xl md:text-6xl lg:text-7xl">
            {heading}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default BannerHeader;
